webpackJsonp([2],{

/***/ "+/lB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Block",
  data: function data() {
    return {
      blockHeight: ''
    };
  },

  methods: {
    fetchData: function fetchData(r) {
      this.blockHeight = r.params.id;
      this.$store.dispatch('getBlockDetail', this.blockHeight);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['blockDetail'])),

  watch: {
    '$route': function $route(r) {
      this.fetchData(r);
    }
  },
  mounted: function mounted() {
    this.fetchData(this.$route);
  }
});

/***/ }),

/***/ "/0re":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blocks-box"},[_c('div',{staticClass:"blocks-header"},[_c('div',{staticClass:"my-header-container"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"my-pages"},[_c('li',[_c('router-link',{attrs:{"to":"/blocks"}},[_c('span',[_c('img',{attrs:{"src":"/static/img/arrow-douleft.png","alt":""}})])])],1),_vm._v(" "),_c('li',[(_vm.page == 1)?_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._m(1)]):_c('router-link',{attrs:{"to":{path:("/blocks?p=" + ((_vm.page-1)))}}},[_c('span',[_c('img',{attrs:{"src":"/static/img/arrow-left.png","alt":""}})])])],1),_vm._v(" "),_c('li',[_c('a',{staticClass:"page-auto",attrs:{"href":"#"}},[_c('b',[_vm._v(_vm._s(_vm.page))]),_vm._v(" / "),_c('b',[_vm._v(_vm._s(_vm.blockInfo.pageLast))])])]),_vm._v(" "),_c('li',[(_vm.page == _vm.blockInfo.pageLast)?_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._m(2)]):_c('router-link',{attrs:{"to":{path:("/blocks?p=" + ((_vm.page+1)))}}},[_c('span',[_c('img',{attrs:{"src":"/static/img/arrow-right.png","alt":""}})])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:("/blocks?p=" + (_vm.blockInfo.pageLast))}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('img',{attrs:{"src":"/static/img/arrow-douright.png","alt":""}})])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"blocks-list"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"list-wrap"},_vm._l((_vm.blockInfo.blockList),function(block){return _c('div',{staticClass:"list-body-wrap"},[_c('ul',{staticClass:"my-list-body"},[_c('li',[_c('router-link',{attrs:{"to":{path:("/block/" + (block.height))}}},[_vm._v(_vm._s(block.height))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:("/account/" + (block.witness))}}},[_vm._v(_vm._s(block.witness))])],1),_vm._v(" "),_c('li',[_vm._v(_vm._s(block.totalGasLimit))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(block.avgGasPrice))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(block.age))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(block.txn))])])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blocks-info"},[_c('h1',[_vm._v("区块")]),_vm._v(" "),_c('h4',[_vm._v("展示 30 条记录")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":"/static/img/arrow-left.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":"/static/img/arrow-right.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"my-list-header"},[_c('li',[_vm._v("Height")]),_vm._v(" "),_c('li',[_vm._v("Witness")]),_vm._v(" "),_c('li',[_vm._v("GasLimit")]),_vm._v(" "),_c('li',[_vm._v("Avg.GasPrice")]),_vm._v(" "),_c('li',[_vm._v("Age")]),_vm._v(" "),_c('li',[_vm._v("Txn")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/GJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bs58__ = __webpack_require__("ZDUk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bs58___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bs58__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_elliptic__ = __webpack_require__("lZ6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_elliptic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_elliptic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_config__ = __webpack_require__("bzuE");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var apis = __WEBPACK_IMPORTED_MODULE_5__utils_config__["a" /* config */].apis;


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ApplyIOST',
	data: function data() {
		return {
			address: '',
			addressx: '',
			auto: 0,
			privKey: '',
			pubKey: '',
			amount: '',
			email: '',
			mobile: '',
			verify: '',
			mobileButtonMsg: 'Send',
			ltime: 0,
			errMsg: '',
			checked: false,
			dott: '',
			accountName: ''
		};
	},


	computed: {
		isOK: function isOK() {
			if (this.address != '' && this.email != '' && this.verify != '' && this.mobile != '') {
				return true;
			} else {
				return false;
			}
		}
	},

	methods: {
		// 替换后的
		randomBytes: function randomBytes(size) {
			var rawBytes = new Uint8Array(size);
			var bytes = void 0;

			crypto.getRandomValues(rawBytes);
			bytes = Buffer.from(rawBytes.buffer);

			return bytes;
		},

		bytesToHex: function bytesToHex(bytes) {
			return bytes.toString('hex');
		},

		getApplyParam: function getApplyParam(grecap) {
			var params = new URLSearchParams();
			if (this.auto == 1) {
				// params.append('address', this.addressx)
				params.append('address', this.address);
			} else {
				params.append('address', this.address);
			}
			params.append('account', this.accountName);
			params.append('email', this.email);
			params.append('gcaptcha', grecap);
			return params;
		},


		apply: function apply() {
			var _this = this;

			if (this.address.length < 35) {
				$('#errAlert').addClass('alert alert-danger');
				this.errMsg = 'invalid account pubKey';
				return false;
			}

			if (this.accountName.length < 5 || this.accountName.length > 11) {
				$('#errAlert').addClass('alert alert-danger');
				this.errMsg = 'invalid account name, must 5-11 characters';
				return false;
			}

			var regExp = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
			if (this.email.length == 0 || !regExp.test(this.email)) {
				$('#errAlert').addClass('alert alert-danger');
				this.errMsg = 'invalid email address';
				return false;
			}

			var grecap = grecaptcha.getResponse();
			if (grecap.length == 0) {
				$('#errAlert').addClass('alert alert-danger');
				this.errMsg = 'invalid google reCaptcha check';
				return false;
			}

			__WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
				html: '',
				title: 'Creating Account...',
				onOpen: function onOpen() {
					__WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.showLoading();
				},
				allowOutsideClick: function allowOutsideClick() {
					return !__WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.isLoading();
				}
			});
			var dotNum = 1;
			var interval = window.setInterval(function () {
				if (dotNum == 6) {
					_this.dott = '......';

					dotNum = 0;
				} else if (dotNum == 5) {
					_this.dott = '.....';
				} else if (dotNum == 4) {
					_this.dott = '....';
				} else if (dotNum == 3) {
					_this.dott = '...';
				} else if (dotNum == 2) {
					_this.dott = '..';
				} else if (dotNum == 1) {
					_this.dott = '.';
				} else if (dotNum == 0) {
					_this.dott = '';
				}
				dotNum++;
			}, 1000);

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + apis.applyIOST, this.getApplyParam(grecap)).then(function (response) {
				var retCode = response.data.ret;
				var txHash = response.data.msg;
				if (retCode != 0) {
					__WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.close();
					$('#applyIOSTModal').modal('hide');
					$('#errAlert').addClass('alert alert-danger');
					_this.errMsg = response.data.msg;
				} else {
					__WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.close();
					$('#applyIOSTModal').modal('hide');
					var pushParams = {};
					if (_this.address.length > 0) {
						pushParams.address = _this.address;
					} else {
						// pushParams.address = this.addressx
						pushParams.address = _this.address;
					}
					pushParams.email = _this.email;
					pushParams.accountName = _this.accountName;
					pushParams.privKey = _this.privKey;
					pushParams.txHash = txHash;
					_this.$router.push({
						name: 'ApplyIOSTSuccess',
						params: pushParams
					});
				}
			});
		}
	},

	watch: {
		checked: function checked() {
			if (this.checked == false) {
				this.privKey = '';
				this.pubKey = '';
				this.address = '';
				$('#applyAddress').attr('disabled', false);
			} else {
				$('#applyAddress').attr('disabled', true);

				var bytes = this.randomBytes(32);
				var EdDSA = __WEBPACK_IMPORTED_MODULE_4_elliptic___default.a.eddsa;
				var ec = new EdDSA('ed25519');
				var key = ec.keyFromSecret(bytes);

				var pubKey = key.pubBytes();

				var privKey = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(bytes));
				privKey.push.apply(privKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(pubKey));

				this.privKey = __WEBPACK_IMPORTED_MODULE_3_bs58___default.a.encode(Buffer.from(privKey));
				this.pubKey = __WEBPACK_IMPORTED_MODULE_3_bs58___default.a.encode(Buffer.from(pubKey));
				this.address = __WEBPACK_IMPORTED_MODULE_3_bs58___default.a.encode(Buffer.from(pubKey));

				console.log(this.pubKey);
				console.log(this.privKey);
				console.log(privKey);

				this.auto = 1;
			}
		}
	},

	mounted: function mounted() {
		$("#phone").intlTelInput();
		var rc = document.getElementsByClassName('g-recaptcha')[0].children;
		setTimeout(function () {
			grecaptcha.render('recap', { "sitekey": "6Lc1vF8UAAAAAMo-EsF4vRt6CWxM8s56lAeyHnBe" });
			if (rc.length == 0) {
				__WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
					title: 'Failed to load google reCaptcha !',
					text: '',
					confirmButtonText: 'try again'
				}).then(function (result) {
					grecaptcha.render('recap', { "sitekey": "6Lc1vF8UAAAAAMo-EsF4vRt6CWxM8s56lAeyHnBe" });
				});
			}
		}, 2000);
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "/Y7x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3Z2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_config__ = __webpack_require__("bzuE");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var apis = __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* config */].apis;


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AccountDetail",
  data: function data() {
    return {
      address: this.$route.params.id,
      addressx: "",
      // account: {},
      txnList: {},
      txnLen: '',
      ContractInfo: {},
      currentTab: false,
      isShow: false // 当接口code返回1时，切换方法不执行
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['accountDetail', 'accountTxnInfo']), {
    showContractCode: function showContractCode() {
      // return this.address.slice(0,4) != 'IOST'
      return this.address.slice(0, 8) == 'Contract';
    }
  }),

  methods: {
    fetchData: function fetchData(r) {
      var _this = this;

      this.address = r.params.id;

      this.$store.dispatch('getAccountDetail', this.address);

      this.$store.dispatch('getAccountTxnInfo', this.address);

      // axios.get('https://explorer.iost.io/api/account/' + this.address).then((response) => {
      //   this.account = response.data
      // })
      // axios.get('https://explorer.iost.io/api/account/' + this.address + '/txs').then((response) => {
      //   this.txnList = response.data.txn_list
      //   this.txnLen = response.data.txn_len
      // })

      this.addressx = this.address.replace('Contract', '');
      // axios.get('https://explorer.iost.io/api/tx/' + this.address).then((response) => {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('' + apis.tx + this.addressx).then(function (response) {
        if (response.data.code == 1) {
          _this.isShow = true;
          return;
        }

        // let blkDate = new Date(response.data.time / 1000 / 1000)
        var blkDate = new Date(response.data.data.utcTime);
        var time = '';
        time += blkDate.getFullYear() + '-';
        time += (blkDate.getMonth() + 1 < 10 ? '0' + (blkDate.getMonth() + 1) : blkDate.getMonth() + 1) + '-';
        time += blkDate.getDate() + ' ';
        if (blkDate.getHours() < 10) {
          time += '0' + blkDate.getHours();
        } else {
          time += blkDate.getHours();
        }
        if (blkDate.getMinutes() < 10) {
          time += ':0' + blkDate.getMinutes();
        } else {
          time += ':' + blkDate.getMinutes();
        }
        if (blkDate.getSeconds() < 10) {
          time += ':0' + blkDate.getSeconds();
        } else {
          time += ':' + blkDate.getSeconds();
        }
        response.data.data.time = time;
        _this.ContractInfo = response.data.data;
      });
    },
    goTab: function goTab(num) {
      if (num == 1) {
        this.currentTab = false;
      } else {
        this.currentTab = true;
      }
    }
  },

  watch: {
    '$route': function $route(r) {
      this.fetchData(r);
    }
  },
  mounted: function mounted() {
    this.fetchData(this.$route);
  }
});

/***/ }),

/***/ "699P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blockDetail-box"},[_c('LuckyBet'),_vm._v(" "),_c('div',{staticClass:"blockDetail-header"},[_c('div',{staticClass:"my-header-container"},[_c('h1',[_vm._v("Block Information")]),_vm._v(" "),_c('p',[_vm._v("#"+_vm._s(_vm.blockHeight))])])]),_vm._v(" "),_c('div',{staticClass:"blockDetail-information"},[_c('img',{attrs:{"src":"/static/img/iostWhite.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"blockDetail-height-txns"},[_c('div',{staticClass:"blockDetail-height"},[_c('h4',[_vm._v("Height:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.blockHeight))])]),_vm._v(" "),_c('div',{staticClass:"blockDetail-txns"},[_c('h4',[_vm._v("Transactions:")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{path:("/txs/?b=" + _vm.blockHeight)}}},[_vm._v(_vm._s(_vm.blockDetail.txn))])],1)])]),_vm._v(" "),_c('div',{staticClass:"blockDetail-time"},[_c('h4',[_vm._v("TimeStamp:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.blockDetail.age)+" ("+_vm._s(_vm.blockDetail.utcTime)+")")])]),_vm._v(" "),_c('div',{staticClass:"blockDetail-hash"},[_c('h4',[_vm._v("Hash:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.blockDetail.blockHash))])]),_vm._v(" "),_c('div',{staticClass:"blockDetail-parent"},[_c('h4',[_vm._v("Parent Hash:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.blockDetail.parentHash))])]),_vm._v(" "),_c('div',{staticClass:"blockDetail-witness"},[_c('h4',[_vm._v("Witness:")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{path:("/account/" + (_vm.blockDetail.witness))}}},[_vm._v(_vm._s(_vm.blockDetail.witness))])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6I2s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6VMs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "70pI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ApplyIOSTSuccess',
	data: function data() {
		return {
			address: this.$route.params.address,
			accountName: this.$route.params.accountName,
			email: this.$route.params.email,
			txHash: this.$route.params.txHash,
			privKey: this.$route.params.privKey
		};
	},

	created: function created() {
		// if (!this.$route.params.txHash) {
		// 	this.$router.push({
		// 		path: '/applyIOST',
		// 	})
		// }
	}
});

/***/ }),

/***/ "7BM8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("70pI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9d8f152_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("8L5o");
function injectStyle (ssrContext) {
  __webpack_require__("6I2s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9d8f152_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "883D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("wUKc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a7b20c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("l2+E");
function injectStyle (ssrContext) {
  __webpack_require__("GYE2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a7b20c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8L5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-box"},[_vm._m(0),_vm._v(" "),(_vm.privKey != '')?_c('div',{staticClass:"success-container1"},[_c('p',{staticClass:"success-title"},[_vm._v("Save your Account Info")]),_vm._v(" "),_c('p',{staticClass:"success-address"},[_c('span',[_vm._v("Account Name:")]),_vm._v(" "+_vm._s(_vm.accountName))]),_vm._v(" "),_c('p',{staticClass:"success-private"},[_c('span',[_vm._v("Private Key:")]),_vm._v(" "+_vm._s(_vm.privKey))]),_vm._v(" "),_c('p',{staticClass:"success-tips"},[_vm._v("**Do not lose it!** It cannot be recovered if you lose it.")]),_vm._v(" "),_c('p',{staticClass:"success-tips"},[_vm._v("**Do not share it!** Your funds will be stolen if you use this private key on a malicious/phishing site.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"success-container2"},[_c('div',{staticClass:"container2-hash"},[_c('h4',[_vm._v("TxHash:")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{path:("/tx/" + _vm.txHash)},"target":"_blank"}},[_vm._v(_vm._s(_vm.txHash))])],1)]),_vm._v(" "),_c('div',{staticClass:"container2-address"},[_c('h4',[_vm._v("Account Name:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.accountName))])]),_vm._v(" "),_c('div',{staticClass:"container2-email"},[_c('h4',[_vm._v("Email:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.email))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-header"},[_c('div',{staticClass:"my-header-container"},[_c('h1',[_vm._v("Request successfully processed")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9ln5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_config__ = __webpack_require__("bzuE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var apis = __WEBPACK_IMPORTED_MODULE_1__utils_config__["a" /* config */].apis;


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Head",
  data: function data() {
    return {
      currentColor: 0,
      currentTheme: true,
      isShow: false,
      searchInput: '',
      menu: false

    };
  },

  watch: {
    '$route': function $route(to) {
      var arr = ['/block', '/tx', '/account', '/applyIOST', '/feedback', '/search', '/luckyBet', '404'];
      var arr2 = arr.filter(function (a, index) {
        return to.path.search(a) + 1;
      });
      var result = arr2.join('');
      if (result == '/block') {
        this.currentColor = 1;
        this.currentTheme = false;
      } else if (result == '/tx') {
        this.currentColor = 2;
        this.currentTheme = false;
      } else if (result == '/account') {
        this.currentColor = 3;
        this.currentTheme = false;
      } else if (result == '/applyIOST') {
        this.currentColor = 4;
        this.currentTheme = false;
      } else if (result == '/feedback') {
        this.currentColor = 5;
        this.currentTheme = false;
      } else if (result == '/search') {
        this.currentColor = 6;
        this.currentTheme = false;
      } else if (result == '/luckyBet') {
        this.currentColor = 7;
        this.currentTheme = false;
      } else if (result == '404') {
        this.currentColor = 8;
        this.currentTheme = false;
      } else {
        this.currentColor = 0;
        this.currentTheme = true;
      }
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (location.pathname != '/') {
        return;
      }
      var heightTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (heightTop >= 60) {
        this.currentTheme = false;
      } else {
        this.currentTheme = true;
      }
    },
    openSearch: function openSearch(e) {
      if (e.stopPropagation) {
        e.stopPropagation();
      }
      this.isShow = !this.isShow;
      if (this.isShow) {
        setTimeout(function () {
          document.querySelector('input').focus();
        });
      }
    },


    // 点击页面其他位置，搜索框隐藏
    onSearch: function onSearch() {
      // 利用事件冒泡
      this.menu = false;
      this.isShow = false;
    },
    searchData: function searchData() {
      var _this = this;

      this.menu = false;
      if (!this.searchInput) return;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apis.search + this.searchInput).then(function (response) {
        var type = response.data.data.type;
        if (type == "block") {
          if (response.data.data.text) {
            _this.$router.push({
              path: '/block/' + response.data.data.text
            });
          } else {
            _this.$router.push({
              path: '/block/' + _this.searchInput
            });
          }
        } else if (type == "account") {
          _this.$router.push({
            path: '/account/' + _this.searchInput
          });
        } else if (type == "tx") {
          _this.$router.push({
            path: '/tx/' + _this.searchInput
          });
        } else {
          _this.$router.push({
            path: '/search/' + _this.searchInput
          });
        }
        _this.searchInput = '';
        _this.isShow = false;
      });
      return false;
    }
  },

  // 为了在当前页刷新之后，依旧保持当前状态
  created: function created() {
    var arr = ['/', '/block', '/tx', '/account', '/applyIOST', '/feedback', '/search', '/luckyBet'];
    var arr2 = arr.filter(function (a, index) {
      return location.pathname.search(a) + 1;
    });
    var result = arr2.join('');
    if (result == '/') {
      this.currentTheme = true;
    } else {
      this.currentTheme = false;
    }
    if (result == '/') {
      this.currentColor = 0;
    } else if (result == '/block') {
      this.currentColor = 1;
    } else if (result == '/tx') {
      this.currentColor = 2;
    } else if (result == '/account') {
      this.currentColor = 3;
    } else if (result == '/applyIOST') {
      this.currentColor = 4;
    } else if (result == '/feedback') {
      this.currentColor = 5;
    } else if (result == '/search') {
      this.currentColor = 6;
    } else if (result == '/luckyBet') {
      this.currentColor = 7;
    }

    // 404页面
    if (location.pathname != result) {
      this.currentColor = 8;
      this.currentTheme = false;
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('click', this.onSearch);
  }
});

/***/ }),

/***/ "A22N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("lg1P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acdee106_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("lsiQ");
function injectStyle (ssrContext) {
  __webpack_require__("gJza")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acdee106_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BD25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("9ln5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb40cee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("lElA");
function injectStyle (ssrContext) {
  __webpack_require__("evj9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4eb40cee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb40cee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BI2O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"txns-box"},[_c('div',{staticClass:"txns-header"},[_c('div',{staticClass:"my-header-container"},[_c('div',{staticClass:"txns-info"},[_c('div',[(_vm.address != '')?_c('h1',[_vm._v("\n            交易\n            "),_c('p',[_vm._v("地址："+_vm._s(_vm.address))])]):(_vm.blk != '')?_c('h1',[_vm._v("\n            交易\n            "),_c('p',[_vm._v("区块："+_vm._s(_vm.blk))])]):_c('h1',[_vm._v("\n            交易\n          ")])]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.txnInfo.totalLen)+" 条交易 (展示 500 条记录)")])]),_vm._v(" "),_c('ul',{staticClass:"my-pages"},[_c('li',[_c('router-link',{attrs:{"to":{path:("/txs?a=" + _vm.address + "&b=" + _vm.blk)}}},[_c('span',[_c('img',{attrs:{"src":"/static/img/arrow-douleft.png","alt":""}})])])],1),_vm._v(" "),_c('li',[(_vm.page == 1)?_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._m(0)]):_c('router-link',{attrs:{"to":{path:("/txs?p=" + ((_vm.page-1)) + "&a=" + _vm.address + "&b=" + _vm.blk)}}},[_c('span',[_c('img',{attrs:{"src":"/static/img/arrow-left.png","alt":""}})])])],1),_vm._v(" "),_c('li',[_c('a',{staticClass:"page-auto",attrs:{"href":"#"}},[_c('b',[_vm._v(_vm._s(_vm.page))]),_vm._v(" / "),_c('b',[_vm._v(_vm._s(_vm.txnInfo.pageLast))])])]),_vm._v(" "),_c('li',[(_vm.page == _vm.txnInfo.pageLast)?_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._m(1)]):_c('router-link',{attrs:{"to":{path:("/txs?p=" + ((_vm.page+1)) + "&a=" + _vm.address + "&b=" + _vm.blk)}}},[_c('span',[_c('img',{attrs:{"src":"/static/img/arrow-right.png","alt":""}})])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:("/txs?p=" + (_vm.txnInfo.pageLast) + "&a=" + _vm.address + "&b=" + _vm.blk)}}},[_c('span',[_c('img',{attrs:{"src":"/static/img/arrow-douright.png","alt":""}})])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"txns-list"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"list-wrap"},_vm._l((_vm.txnInfo.txsList),function(tx,index){return _c('div',{key:index,staticClass:"list-body-wrap"},[_c('ul',{staticClass:"my-list-body"},[_c('li',[_c('router-link',{attrs:{"to":{path:("/block/" + (tx.blockHeight))}}},[_vm._v(_vm._s(tx.blockHeight))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:("/tx/" + (tx.txHash))}}},[_vm._v(_vm._s(tx.txHash))])],1),_vm._v(" "),_c('li',[(_vm.address == tx.from)?_c('span',[_vm._v(_vm._s(tx.from))]):(tx.from !='_Block_Base')?_c('router-link',{attrs:{"to":{path:("/account/" + (tx.from))}}},[_vm._v(_vm._s(tx.from))]):_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(tx.from))])],1),_vm._v(" "),_c('li',[(tx.state == 0)?_c('img',{attrs:{"src":"/static/img/failure.png","alt":""}}):_c('img',{attrs:{"src":"/static/img/success.png","alt":""}})]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:("/account/" + (tx.to))}}},[_vm._v(_vm._s(tx.to)+"...")])],1),_vm._v(" "),_c('li',[_vm._v(_vm._s(tx.age))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(tx.amount/100000000)+" IOST")])])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":"/static/img/arrow-left.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":"/static/img/arrow-right.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"my-list-header"},[_c('li',[_vm._v("Height")]),_vm._v(" "),_c('li',[_vm._v("TxHash")]),_vm._v(" "),_c('li',[_vm._v("From")]),_vm._v(" "),_c('li'),_vm._v(" "),_c('li',[_vm._v("To")]),_vm._v(" "),_c('li',[_vm._v("Age")]),_vm._v(" "),_c('li',[_vm._v("Value")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BRZl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("YRQz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5285536f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("NBwZ");
function injectStyle (ssrContext) {
  __webpack_require__("EiPC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5285536f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EBaw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchPages',
  data: function data() {
    return {
      searchInput: this.$route.params.id
    };
  },

  watch: {
    '$route': function $route(r) {
      this.searchInput = r.params.id;
    }
  }
});

/***/ }),

/***/ "EiPC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GYE2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hxdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_config__ = __webpack_require__("bzuE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var apis = __WEBPACK_IMPORTED_MODULE_2__utils_config__["a" /* config */].apis;


/* harmony default export */ __webpack_exports__["a"] = ({
	name: "Feedback",
	data: function data() {
		return {
			email: '',
			content: '',
			errMsg: ''
		};
	},


	computed: {
		isOK: function isOK() {
			if (this.email != '' && this.content != '') {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		sendFeedback: function sendFeedback() {
			var regExp = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
			if (this.email.length == 0 || !regExp.test(this.email)) {
				$('#errFeedbackAlert').addClass('alert alert-danger');
				this.errMsg = 'invalid email address';
				return false;
			}

			if (this.content.length == 0 || this.content.length < 100) {
				$('#errFeedbackAlert').addClass('alert alert-danger');
				this.errMsg = 'feedback content length must be greater than 100';
				return false;
			}

			var params = new URLSearchParams();
			params.append('email', this.email);
			params.append('content', this.content);

			// axios.post('https://explorer.iost.io/api/feedback', params).then((response) => {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + apis.search, params).then(function (response) {
				__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('Feedback success!', '', 'success').then(function (router) {
					window.location.href = "/";
				});
			});
		}
	}
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("UjVw");

/*
* vuex核心管理对象 store模块
* */









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */]
}));

/***/ }),

/***/ "IrLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("EBaw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190fefe5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("rujA");
function injectStyle (ssrContext) {
  __webpack_require__("uJYF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190fefe5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J0VS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Tx",
  data: function data() {
    return {
      txHash: ''
    };
  },

  methods: {
    fetchData: function fetchData(r) {
      this.txHash = r.params.id;

      this.$store.dispatch('getTxnDetail', this.txHash);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['txnDetail'])),

  watch: {
    '$route': function $route(r) {
      this.fetchData(r);
    }
  },
  mounted: function mounted() {
    this.fetchData(this.$route);
  }
});

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.5.3","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6bdd47e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("wdrB");
function injectStyle (ssrContext) {
  __webpack_require__("nyL6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6bdd47e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MZyj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NBwZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-box"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"flex content-space-between",attrs:{"id":"#contact"}},[_c('div',{staticClass:"title-col"},[_c('p',{staticClass:"title mb-30"},[_c('a',{attrs:{"href":"/about"}},[_vm._v("关于我们")])]),_vm._v(" "),_c('p',{staticClass:"title mb-30"},[_c('a',{attrs:{"target":"_blank","href":"https://developer.aioukeji.net/docs/en/1-getting-started/Overview.html"}},[_vm._v("开发文档")])]),_vm._v(" "),_c('p',{staticClass:"title mb-30"},[_c('a',{attrs:{"href":"/joinus"}},[_vm._v("加入我们")])])]),_vm._v(" "),_c('div',{staticClass:"ivu-col"},[_c('div',{staticClass:"title flex am_c"},[_c('i',{staticClass:"mr-10"},[_c('img',{attrs:{"src":"/static/img/mail.png","width":"28"}})]),_vm._v(" "),_c('div',[_vm._v("联系我们")])]),_vm._v(" "),_c('div',{staticClass:"footer_divider ml-5 mt-10 mb-10"}),_vm._v(" "),_c('p',{staticClass:"info"},[_c('a',{attrs:{"href":"mailto:bd@aioukeji.net"}},[_vm._v("北京总部 - bd@aioukeji.net")])]),_vm._v(" "),_c('p',{staticClass:"info"},[_c('a',{attrs:{"href":"mailto:bd@aioukeji.net"}},[_vm._v("宁波分部 - nb@aioukeji.net")])]),_vm._v(" "),_c('p',{staticClass:"info"},[_c('a',{attrs:{"href":"mailto:bd@aioukeji.net"}},[_vm._v("长沙分部 - cs@aioukeji.net")])]),_vm._v(" "),_c('p',{staticClass:"info mb_30"},[_c('a',{attrs:{"href":"mailto:support@aioukeji.net"}},[_vm._v("技术支持 - support@aioukeji.net")])])]),_vm._v(" "),_c('div',{staticClass:"flex col am_c ivu-col"},[_c('p',{staticClass:"title"},[_vm._v("微信公众号")]),_vm._v(" "),_c('div',{staticClass:"footer_divider mt-10 mb-10"}),_vm._v(" "),_c('img',{staticClass:"wechat-qrcode",attrs:{"src":"/static/img/wechat.png","width":"110"}})])])]),_vm._v(" "),_c('p',{staticClass:"copyright"},[_vm._v("© 2020 aioukeji.net 版权所有 "),_c('a',[_vm._v("京ICP备 19056179号-1")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_less__ = __webpack_require__("6VMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nprogress_nprogress_css__ = __webpack_require__("UVIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_nprogress_nprogress_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







//引入nprogress

 //这个样式必须引入

// 简单配置
__WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.inc(0.2);
__WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.configure({ easing: 'ease', speed: 1000, showSpinner: false, minimum: 0.1 });

// 全局前置守卫
__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.start();
  next();
});

// 全部后置钩子
__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].afterEach(function () {
  __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.done();
});

// import './style.less'


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]
});

/***/ }),

/***/ "Nglo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
		name: 'Bonus',
		data: function data() {
				return {
						account: '-',
						bonusVal: '-',
						bpVal: '-',
						iost: null
				};
		},


		methods: {
				delay: function delay(n) {
						n = n || 500;
						return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (done) {
								setTimeout(function () {
										done();
								}, n);
						});
				},


				withdrawVote: function withdrawVote() {
						if (this.bonusVal <= 0) return;
						var tx = this.iost.callABI("vote_producer.iost", "candidateWithdraw", [this.account]);
						tx.setGas(1, 2000000);

						self = this;
						var txHash;
						this.iost.signAndSend(tx).on('pending', function (txid) {
								txHash = txid;
								__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
										title: '正在发送',
										html: 'txid: <a target=_blank href="https://www.iostabc.com/tx/' + txid + '">' + txid + '</a>',
										onBeforeOpen: function onBeforeOpen() {
												__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.showLoading();
										},
										allowOutsideClick: function allowOutsideClick() {
												return !__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.isLoading();
										}
								});
								console.log("txid:", txid);
						}).on('success', function (result) {
								__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.close();
								__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
										type: 'success',
										title: '领取成功',
										html: 'txid: <a target=_blank href="https://www.iostabc.com/tx/' + txHash + '">' + txHash + '</a>'
								});
								self.bonusVal = 0;
								console.log("res:", result, txHash);
						}).on('failed', function (failed) {
								__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.close();
								__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
										type: 'error',
										title: '领取失败',
										html: 'txid: <a target=_blank href="https://www.iostabc.com/tx/' + txHash + '">' + txHash + '</a>'
								});
								console.log(failed);
						});
				},

				withdrawBp: function withdrawBp() {
						if (this.bpVal <= 0) return;
						var tx = this.iost.callABI("bonus.iost", "exchangeIOST", [this.account, '0']);
						tx.setGas(1, 2000000);

						self = this;
						var txHash;
						this.iost.signAndSend(tx).on('pending', function (txid) {
								txHash = txid;
								__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
										title: '正在发送',
										html: 'txid: <a target=_blank href="https://www.iostabc.com/tx/' + txid + '">' + txid + '</a>',
										onBeforeOpen: function onBeforeOpen() {
												__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.showLoading();
										},
										allowOutsideClick: function allowOutsideClick() {
												return !__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.isLoading();
										}
								});
								console.log("txid:", txid);
						}).on('success', function (result) {
								__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.close();
								__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
										type: 'success',
										title: '领取成功',
										html: 'txid: <a target=_blank href="https://www.iostabc.com/tx/' + txHash + '">' + txHash + '</a>'
								});
								self.bonusVal = 0;
								console.log("res:", result, txHash);
						}).on('failed', function (failed) {
								__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.close();
								__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
										type: 'error',
										title: '领取失败',
										html: 'txid: <a target=_blank href="https://www.iostabc.com/tx/' + txHash + '">' + txHash + '</a>'
								});
								console.log(failed);
						});
				}
		},

		created: function created() {
				var s = document.createElement('script');
				s.type = 'text/javascript';
				s.src = 'https://cdn.jsdelivr.net/npm/iost@0.1.2/iost.min.js';
				document.body.appendChild(s);
		},
		mounted: function mounted() {
				var _this = this;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
								while (1) {
										switch (_context.prev = _context.next) {
												case 0:
														_context.next = 2;
														return _this.delay(600);

												case 2:
														if (typeof IWalletJS === 'undefined') {
																__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
																		type: 'error',
																		text: '无法加载钱包，请确认Chrome插件已正确安装'
																});
														}
														self = _this;

														IWalletJS.enable().then(function (account) {
																console.log(account);
																if (!account) {
																		__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
																				type: 'error',
																				text: '无法加载钱包，请确认私钥已正确导入'
																		});
																		return;
																}
																self.account = account;

																__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://api.iost.io/getCandidateBonus/' + account + '/1').then(function (response) {
																		self.bonusVal = response.data.bonus / 2;
																});

																__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://api.iost.io/getTokenBalance/' + account + '/contribute/1').then(function (response) {
																		self.bpVal = response.data.balance;
																});

																self.iost = IWalletJS.newIOST(IOST);
														});

												case 5:
												case 'end':
														return _context.stop();
										}
								}
						}, _callee, _this);
				}))();
		}
});

/***/ }),

/***/ "NzQd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Txns",
  data: function data() {
    return {
      page: '',
      address: '',
      blk: ''
    };
  },

  methods: {
    fetchData: function fetchData(r) {
      if (!r.query.p) {
        this.page = 1;
      } else {
        this.page = parseInt(r.query.p);
      }

      this.address = '';
      if (this.$route.query.a) {
        this.address = this.$route.query.a;
      }
      this.blk = '';
      if (this.$route.query.b) {
        this.blk = this.$route.query.b;
      }

      this.$store.dispatch('getTxnInfo', { page: this.page, address: this.address, blk: this.blk });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['txnInfo'])),

  watch: {
    '$route': function $route(r) {
      this.fetchData(r);
    }
  },
  mounted: function mounted() {
    this.fetchData(this.$route);
  }
});

/***/ }),

/***/ "O+20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Nglo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0efa1a91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("xIGC");
function injectStyle (ssrContext) {
  __webpack_require__("/Y7x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0efa1a91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OG5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"txnsDetail-box"},[_c('div',{staticClass:"txnsDetail-header"},[_c('div',{staticClass:"my-header-container"},[_c('h1',[_vm._v("Transaction Information")]),_vm._v(" "),_c('p',[_vm._v("#"+_vm._s(_vm.txHash))])])]),_vm._v(" "),_c('div',{staticClass:"txnsDetail-information"},[_c('img',{attrs:{"src":"/static/img/iostWhite.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"txnsDetail-hash"},[_c('h4',[_vm._v("TxHash:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.txHash))])]),_vm._v(" "),_c('div',{staticClass:"txnsDetail-block-time"},[_c('div',{staticClass:"txnsDetail-block"},[_c('h4',[_vm._v("Block Height:")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{path:("/block/" + (_vm.txnDetail.blockHeight))}}},[_vm._v(_vm._s(_vm.txnDetail.blockHeight))])],1)]),_vm._v(" "),_c('div',{staticClass:"txnsDetail-time"},[_c('h4',[_vm._v("TimeStamp:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.txnDetail.age)+"("+_vm._s(_vm.txnDetail.utcTime)+")")])])]),_vm._v(" "),_c('div',{staticClass:"txnsDetail-from"},[_c('h4',[_vm._v("From:")]),_vm._v(" "),_c('p',[(_vm.txnDetail.from !='_Block_Base')?_c('router-link',{attrs:{"to":{path:("/account/" + (_vm.txnDetail.from))}}},[_vm._v(_vm._s(_vm.txnDetail.from))]):_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.txnDetail.from))])],1)]),_vm._v(" "),(_vm.txnDetail.actionName != 'transfer')?_c('div',{staticClass:"txnsDetail-to"},[_c('h4',[_vm._v("To:")]),_vm._v(" "),(_vm.txnDetail.to == 'iost.system')?_c('p',[_vm._v(_vm._s(_vm.txnDetail.to))]):_vm._e(),_vm._v(" "),_c('p',[_c('span',[_vm._v("actionName：")]),_vm._v(_vm._s(_vm.txnDetail.actionName))]),_vm._v(" "),(_vm.txnDetail.actionName == 'SetCode')?_c('div',{staticClass:"my-pre"},[_c('span',[_vm._v("code：")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.txnDetail.code))])]):_c('div',{staticClass:"my-pre-normal"},[_c('span',[_vm._v("data：")]),_c('pre',[_vm._v(_vm._s(_vm.txnDetail.data))])])]):_c('div',{staticClass:"txnsDetail-to"},[_c('h4',[_vm._v("To:")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{path:("/account/" + (_vm.txnDetail.to))}}},[_vm._v(_vm._s(_vm.txnDetail.to))])],1)]),_vm._v(" "),(_vm.txnDetail.memo != '')?_c('div',{staticClass:"txnsDetail-to"},[_c('h4',[_vm._v("Memo:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.txnDetail.memo))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"txnsDetail-value-gas"},[_c('div',{staticClass:"txnsDetail-value"},[_c('h4',[_vm._v("Value:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.txnDetail.amount)+" IOST")])]),_vm._v(" "),_c('div',{staticClass:"txnsDetail-gas-limit"},[_c('h4',[_vm._v("Gas Limit:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.txnDetail.gasLimit))])]),_vm._v(" "),_c('div',{staticClass:"txnsDetail-gas-price"},[_c('h4',[_vm._v("Gas Price:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.txnDetail.price))])])]),_vm._v(" "),(_vm.txnDetail.code)?_c('div',[_c('h4',[_vm._v("Code")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.txnDetail.code))])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PtlI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("J0VS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f48b1ce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("OG5M");
function injectStyle (ssrContext) {
  __webpack_require__("yfzl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f48b1ce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S80s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("TxA0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3d083c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("/0re");
function injectStyle (ssrContext) {
  __webpack_require__("g17Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3d083c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TS7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accountDetail-box"},[_c('div',{staticClass:"accountDetail-header"},[_c('div',{staticClass:"my-header-container"},[_c('h1',[_vm._v("Address")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.address))])])]),_vm._v(" "),_c('div',{staticClass:"accountDetail-info"},[_c('div',{staticClass:"accountDetail-tips"},[_c('img',{attrs:{"src":"/static/img/iostWhite.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"accountDetail-height-value"},[_c('div',{staticClass:"accountDetail-height"},[_c('h4',[_vm._v("Balance:")]),_vm._v(" "),(_vm.accountDetail.balance)?_c('p',[_vm._v(_vm._s((_vm.accountDetail.balance/100000000).toFixed(2)))]):_c('p',[_vm._v("0.00")])]),_vm._v(" "),_c('div',{staticClass:"accountDetail-value"},[_c('h4',[_vm._v("IOST Value:")]),_vm._v(" "),(_vm.accountDetail.value)?_c('p',[_vm._v(_vm._s(_vm.accountDetail.value.toFixed(2)))]):_c('p',[_vm._v("0.00")])])])]),_vm._v(" "),_c('ul',{staticClass:"my-tab"},[_c('li',{class:{active: _vm.currentTab},on:{"click":function($event){return _vm.goTab(1)}}},[_vm._v("Transactions")]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContractCode),expression:"showContractCode"}],class:{active: !_vm.currentTab},on:{"click":function($event){return _vm.goTab(2)}}},[_vm._v("Contract Code")])]),_vm._v(" "),_c('div',{staticClass:"my-tab-content"},[(!_vm.currentTab)?_c('div',{staticClass:"my-tab-pane1"},[_c('div',{staticClass:"pane1-header"},[_c('p',{staticClass:"pane1-title"},[_vm._v(_vm._s(_vm.accountTxnInfo.txnLen))]),_vm._v(" "),_c('div',{staticClass:"pane1-content"},[_c('p',[_vm._v("\n              Latest 25 txns from a total Of\n              "),_c('router-link',{attrs:{"to":{path:("/txs?a=" + _vm.address)}}},[_vm._v(_vm._s(_vm.accountTxnInfo.txnLen)+" transactions")])],1),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{path:("/txs?a=" + _vm.address)}}},[_vm._v("View All")])],1)])]),_vm._v(" "),_c('div',{staticClass:"accountDetail-list"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"list-wrap"},_vm._l((_vm.accountTxnInfo.txnList),function(tx){return _c('div',{staticClass:"list-body-wrap"},[_c('ul',{staticClass:"my-list-body"},[_c('li',[_c('router-link',{attrs:{"to":{path:("/block/" + (tx.blockNumber))}}},[_vm._v(_vm._s(tx.blockNumber))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:("/tx/" + (tx.hash))}}},[_vm._v(_vm._s(tx.hash)+"...")])],1),_vm._v(" "),_c('li',[(tx.from !='_Block_Base')?_c('router-link',{attrs:{"to":{path:("/account/" + (tx.from))}}},[_vm._v(_vm._s(tx.from))]):_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(tx.from))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:("/account/" + (tx.to))}}},[_vm._v(_vm._s(tx.to))])],1),_vm._v(" "),_c('li',[_vm._v(_vm._s(tx.age))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(tx.amount))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(tx.gasPrice))])])])}),0)])]):_c('div',{staticClass:"my-tab-pane2"},[_c('div',{staticClass:"pane2-tips1"},[_c('h4',[_vm._v("Publisher:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.ContractInfo.from))])]),_vm._v(" "),_c('div',{staticClass:"pane2-tips2"},[_c('h4',[_vm._v("Time:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.ContractInfo.time))])]),_vm._v(" "),_c('div',{staticClass:"pane2-tips3"},[_c('h4',[_vm._v("Code:")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.ContractInfo.code))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"my-list-header"},[_c('li',[_vm._v("Height")]),_vm._v(" "),_c('li',[_vm._v("TxHash")]),_vm._v(" "),_c('li',[_vm._v("From")]),_vm._v(" "),_c('li',[_vm._v("To")]),_vm._v(" "),_c('li',[_vm._v("Age")]),_vm._v(" "),_c('li',[_vm._v("Value")]),_vm._v(" "),_c('li',[_vm._v("[TxFee]")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TbzR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
* 包含 n 个mutation的type常量
* */

var types = {
  INDEXBLOCKLIST: 'indexBlocks',
  MARKETINFO: 'marketInfo',
  INDEXTXNLIST: 'indexTxnList',

  BLOCKINFO: 'blockInfo',
  BLOCKDETAIL: 'blockDetail',

  TXNINFO: 'txnInfo',
  TXNDETAIL: 'txnDetail',

  ACCOUNTINFO: 'accountInfo',
  ACCOUNTDETAIL: 'accountDetail',
  ACCOUNTTXNINFO: 'accountTxnInfo'

};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),

/***/ "TxA0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Blocks",
  data: function data() {
    return {
      page: ''
    };
  },

  methods: {
    fetchData: function fetchData(r) {
      if (!r.query.p) {
        this.page = 1;
      } else {
        this.page = parseInt(r.query.p);
      }

      this.$store.dispatch('getBlockInfo', this.page);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['blockInfo'])),

  watch: {
    '$route': function $route(r) {
      this.fetchData(r);
    }
  },
  mounted: function mounted() {
    this.fetchData(this.$route);
  }
});

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
包含多个基于state的getter计算属性的对象
 */

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "YRQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Foot"
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__("BD25");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Footer__ = __webpack_require__("BRZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Blocks__ = __webpack_require__("S80s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_BlockDetail__ = __webpack_require__("Zquv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Txns__ = __webpack_require__("dKUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_TxnsDetail__ = __webpack_require__("PtlI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Accounts__ = __webpack_require__("883D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_AccountDetail__ = __webpack_require__("rukW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Search__ = __webpack_require__("IrLP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_ApplyIOST__ = __webpack_require__("nS9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_ApplyIOSTSuccess__ = __webpack_require__("7BM8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_404__ = __webpack_require__("bCoe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Feedback__ = __webpack_require__("ZIHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_BPList__ = __webpack_require__("A22N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Bonus__ = __webpack_require__("O+20");




var Index = function Index() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "wDQo"));
};

// import Index from '../pages/Home'














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  // 切换路由后，回到顶部
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{
    path: '/',
    name: 'Index',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: Index,
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/blocks',
    name: 'Blocks',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_4__pages_Blocks__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/block/:id',
    name: 'Block',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_5__pages_BlockDetail__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/txs',
    name: 'Txs',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_6__pages_Txns__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/tx/:id',
    name: 'Tx',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_7__pages_TxnsDetail__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/accounts',
    name: 'Accounts',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_8__pages_Accounts__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/account/:id',
    name: 'AccountDetail',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_9__pages_AccountDetail__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/search/:id',
    name: 'ExplorerSearch',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_10__pages_Search__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/applyIOST',
    name: 'ApplyIOST',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_11__pages_ApplyIOST__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/applyIOST/success',
    name: 'ApplyIOSTSuccess',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_12__pages_ApplyIOSTSuccess__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/feedback',
    name: 'Feedback',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_14__pages_Feedback__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/BPList',
    name: 'BPList',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_15__pages_BPList__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '/bonusWithdraw',
    name: 'bonusWithdraw',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_16__pages_Bonus__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }, {
    path: '*',
    name: '404',
    components: {
      Head: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
      Main: __WEBPACK_IMPORTED_MODULE_13__pages_404__["a" /* default */],
      Foot: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
    }
  }]
}));

/***/ }),

/***/ "ZIHb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Hxdt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad351258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("xGI/");
function injectStyle (ssrContext) {
  __webpack_require__("si88")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad351258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zquv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("+/lB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8d69006_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("699P");
function injectStyle (ssrContext) {
  __webpack_require__("vgtk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8d69006_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bCoe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("uuQF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77d6bfd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("jNb6");
function injectStyle (ssrContext) {
  __webpack_require__("ualu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77d6bfd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bzuE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });

// const APIV1 = 'http://47.244.109.92:8008/api/'
var APIV1 = '/api/';

var config = {
  apis: {
    market: APIV1 + 'market',
    indexBlocks: APIV1 + 'indexBlocks',
    indexTxns: APIV1 + 'indexTxns',

    blocks: APIV1 + 'blocks',
    block: APIV1 + 'block/',

    txs: APIV1 + 'txs',
    tx: APIV1 + 'tx/',

    accounts: APIV1 + 'accounts',
    account: APIV1 + 'account/',

    search: APIV1 + 'search/',

    sendSMS: APIV1 + 'sendSMS',

    feedback: APIV1 + 'feedback',

    applyIOST: APIV1 + 'applyIOST'
  }
};



/***/ }),

/***/ "dKUI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("NzQd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acd602c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("BI2O");
function injectStyle (ssrContext) {
  __webpack_require__("jWv3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acd602c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "evj9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fJxb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g17Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gJza":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container iost-404"},[_c('div',{staticClass:"dialog"},[_c('h1',[_vm._v("Whoops!")]),_vm._v(" "),_c('p',[_vm._v("We were unable to find the page you were looking for")])]),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"src":"/static/img/404.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jWv3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l2+E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accounts-box"},[_c('div',{staticClass:"accounts-header"},[_c('div',{staticClass:"my-header-container"},[_c('div',{staticClass:"accounts-header-info"},[_c('h1',[_vm._v("All Accounts")]),_vm._v(" "),_c('div',{staticClass:"accounts-info"},[(_vm.accountInfo.pageLast * 25 < 500 )?_c('h4',[_vm._v(_vm._s(_vm.accountInfo.totalLen)+" accounts found")]):_c('h4',[_vm._v(_vm._s(_vm.accountInfo.totalLen)+" accounts found (showing the last 500 records)")])])]),_vm._v(" "),_c('ul',{staticClass:"my-pages"},[_c('li',[_c('router-link',{attrs:{"to":"/accounts"}},[_c('span',[_c('img',{attrs:{"src":"/static/img/arrow-douleft.png","alt":""}})])])],1),_vm._v(" "),_c('li',[(_vm.page == 1)?_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._m(0)]):_c('router-link',{attrs:{"to":{path:("/accounts?p=" + ((_vm.page-1)))}}},[_c('span',[_c('img',{attrs:{"src":"/static/img/arrow-left.png","alt":""}})])])],1),_vm._v(" "),_c('li',[_c('a',{staticClass:"page-auto",attrs:{"href":"#"}},[_c('b',[_vm._v(_vm._s(_vm.page))]),_vm._v(" / "),_c('b',[_vm._v(_vm._s(_vm.accountInfo.pageLast))])])]),_vm._v(" "),_c('li',[(_vm.page == _vm.accountInfo.pageLast)?_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._m(1)]):_c('router-link',{attrs:{"to":{path:("/accounts?p=" + ((_vm.page+1)))}}},[_c('span',[_c('img',{attrs:{"src":"/static/img/arrow-right.png","alt":""}})])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:("/accounts?p=" + (_vm.accountInfo.pageLast))}}},[_c('span',[_c('img',{attrs:{"src":"/static/img/arrow-douright.png","alt":""}})])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"accounts-list"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"list-wrap"},_vm._l((_vm.accountInfo.accountList),function(account,index){return _c('div',{staticClass:"list-body-wrap"},[_c('ul',{staticClass:"my-list-body"},[_c('li',[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:("/account/" + (account.address))}}},[_vm._v(_vm._s(account.address))])],1),_vm._v(" "),_c('li',[_vm._v(_vm._s((account.balance/100000000).toFixed(2)))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(account.txCount))])])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":"/static/img/arrow-left.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":"/static/img/arrow-right.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"my-list-header"},[_c('li',[_vm._v("Rank")]),_vm._v(" "),_c('li',[_vm._v("Address")]),_vm._v(" "),_c('li',[_vm._v("Balance")]),_vm._v(" "),_c('li',[_vm._v("TxCount")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lElA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-box",class:{active: _vm.currentTheme}},[_c('div',{staticClass:"my-container"},[_c('div',{staticClass:"logo-box"},[_c('router-link',{staticClass:"logo-link",attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/static/img/aioulogo.svg","alt":""}})])],1),_vm._v(" "),_c('div',[_c('ul',{staticClass:"my-nav-box"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShow),expression:"!isShow"}],staticClass:"my-nav-item",class:{active: _vm.currentColor == 0}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("首页")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShow),expression:"!isShow"}],staticClass:"my-nav-item",class:{active: _vm.currentColor == 1}},[_c('router-link',{attrs:{"to":"/blocks"}},[_vm._v("区块")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShow),expression:"!isShow"}],staticClass:"my-nav-item",class:{active: _vm.currentColor == 2}},[_c('router-link',{attrs:{"to":"/txs"}},[_vm._v("交易")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"my-nav-item searchActive"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.searchInput),expression:"searchInput",modifiers:{"trim":true}}],attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.searchInput)},on:{"click":function($event){$event.stopPropagation();},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchData($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.currentTheme),expression:"!currentTheme"}],class:['my-nav-item', _vm.isShow?'searchActive':'']},[_c('img',{attrs:{"src":"/static/img/search.png","alt":""},on:{"click":_vm.openSearch}})])]),_vm._v(" "),_c('div',{staticClass:"mobile-box"},[_c('i',{class:{active: _vm.menu},on:{"click":function($event){$event.stopPropagation();_vm.menu = !_vm.menu}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.menu),expression:"menu"}],staticClass:"mobile-nav-box"},[_c('li',{staticClass:"mobile-nav-item",class:{active: _vm.currentColor == 0}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("首页")])],1),_vm._v(" "),_c('li',{staticClass:"mobile-nav-item",class:{active: _vm.currentColor == 1}},[_c('router-link',{attrs:{"to":"/blocks"}},[_vm._v("区块")])],1),_vm._v(" "),_c('li',{staticClass:"mobile-nav-item",class:{active: _vm.currentColor == 2}},[_c('router-link',{attrs:{"to":"/txs"}},[_vm._v("交易")])],1),_vm._v(" "),_c('li',{staticClass:"mobile-nav-item"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.searchInput),expression:"searchInput",modifiers:{"trim":true}}],attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.searchInput)},on:{"click":function($event){$event.stopPropagation();},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchData($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/search.png","alt":""},on:{"click":_vm.searchData}})])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lg1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BPList",
  data: function data() {
    return {
      bpList: []
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/BPList').then(function (response) {
        _this.bpList = response.data.data;
      });
    }
  },

  mounted: function mounted() {
    this.fetchData();
  }
});

/***/ }),

/***/ "lsiQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BPList-box"},[_c('div',{staticClass:"BPList-header"},[_c('div',{staticClass:"my-header-container"},[_c('div',{staticClass:"BPList-header-info"},[_c('h1',[_vm._v("BPList")]),_vm._v(" "),_c('h4',[_vm._v("showing total "+_vm._s(_vm.bpList.length)+" BPs")])])])]),_vm._v(" "),_c('div',{staticClass:"bp-list"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"list-wrap"},_vm._l((_vm.bpList),function(bp){return _c('div',{staticClass:"list-body-wrap"},[_c('ul',{staticClass:"my-list-body"},[_c('li',[_vm._v(_vm._s(bp.name))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(bp.pubkey))]),_vm._v(" "),(bp.loc == '')?_c('li',[_vm._v("-")]):_c('li',[_vm._v(_vm._s(bp.loc))]),_vm._v(" "),(bp.url == '')?_c('li',[_vm._v("-")]):_c('li',[_c('a',{attrs:{"href":bp.url,"target":"_blank"}},[_vm._v(_vm._s(bp.name))])]),_vm._v(" "),(bp.online == true)?_c('li',{staticClass:"online"}):_c('li',{staticClass:"offline"})])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"my-list-header"},[_c('li',[_vm._v("Name")]),_vm._v(" "),_c('li',[_vm._v("PubKey")]),_vm._v(" "),_c('li',[_vm._v("Location")]),_vm._v(" "),_c('li',[_vm._v("Url")]),_vm._v(" "),_c('li',[_vm._v("Online")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
* 状态对象
* */

/* harmony default export */ __webpack_exports__["a"] = ({
  indexBlockList: [],
  // marketInfo: [],
  indexTxnList: [],
  blockInfo: {},
  blockDetail: {},

  txnInfo: {},
  txnDetail: {},

  accountInfo: {},
  accountDetail: {},
  accountTxnInfo: {}

});

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bs58__ = __webpack_require__("ZDUk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bs58___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bs58__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("TbzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_config__ = __webpack_require__("bzuE");







var apis = __WEBPACK_IMPORTED_MODULE_5__utils_config__["a" /* config */].apis;


/* harmony default export */ __webpack_exports__["a"] = ({
  getIndexBlockList: function getIndexBlockList(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(apis.indexBlocks);

            case 2:
              _ref2 = _context.sent;
              data = _ref2.data;

              if (data.code == 0) {
                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].INDEXBLOCKLIST, { indexBlockList: data.data.splice(0, 5) });
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  // async getMarketInfo ({commit}) {
  //   const { data } = await axios.get(apis.market)
  //   if(data.code == 0){
  //     commit(types.MARKETINFO, {marketInfo: data.data})
  //   }
  // },

  getIndexTxnList: function getIndexTxnList(_ref3) {
    var _this2 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _ref4, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(apis.indexTxns);

            case 2:
              _ref4 = _context2.sent;
              data = _ref4.data;

              if (data.code == 0) {
                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].INDEXTXNLIST, { indexTxnList: data.data.splice(0, 5) });
              }

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getBlockInfo: function getBlockInfo(_ref5, pages) {
    var _this3 = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var _ref6, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(apis.blocks + '?p=' + pages);

            case 2:
              _ref6 = _context3.sent;
              data = _ref6.data;

              if (data.code == 0) {
                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].BLOCKINFO, { blockInfo: data.data });
              }

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getBlockDetail: function getBlockDetail(_ref7, pages) {
    var _this4 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _ref8, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('' + apis.block + pages);

            case 2:
              _ref8 = _context4.sent;
              data = _ref8.data;

              if (data.code == 0) {
                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].BLOCKDETAIL, { blockDetail: data.data });
              }

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getTxnInfo: function getTxnInfo(_ref9, _ref10) {
    var _this5 = this;

    var commit = _ref9.commit;
    var page = _ref10.page,
        _ref10$address = _ref10.address,
        address = _ref10$address === undefined ? '' : _ref10$address,
        _ref10$blk = _ref10.blk,
        blk = _ref10$blk === undefined ? '' : _ref10$blk;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var _ref11, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(apis.txs + '?page=' + page + '&account=' + address + '&block=' + blk);

            case 2:
              _ref11 = _context5.sent;
              data = _ref11.data;


              if (data.code == 0) {
                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].TXNINFO, { txnInfo: data.data });
              }

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getTxnDetail: function getTxnDetail(_ref12, txHash) {
    var _this6 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var _ref13, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('' + apis.tx + txHash);

            case 2:
              _ref13 = _context6.sent;
              data = _ref13.data;

              if (data.code == 0) {
                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].TXNDETAIL, { txnDetail: data.data });
              }

            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getAccountInfo: function getAccountInfo(_ref14, pages) {
    var _this7 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var _ref15, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(apis.accounts + '?p=' + pages);

            case 2:
              _ref15 = _context7.sent;
              data = _ref15.data;

              if (data.code == 0) {
                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ACCOUNTINFO, { accountInfo: data.data });
              }

            case 5:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  getAccountDetail: function getAccountDetail(_ref16, address) {
    var _this8 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var _ref17, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('' + apis.account + address);

            case 2:
              _ref17 = _context8.sent;
              data = _ref17.data;

              if (data.code == 0) {
                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ACCOUNTDETAIL, { accountDetail: data.data });
              }

            case 5:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  getAccountTxnInfo: function getAccountTxnInfo(_ref18, address) {
    var _this9 = this;

    var commit = _ref18.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var _ref19, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('' + apis.account + address + '/txs');

            case 2:
              _ref19 = _context9.sent;
              data = _ref19.data;

              if (data.code == 0) {
                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ACCOUNTTXNINFO, { accountTxnInfo: data.data });
              }

            case 5:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  }
});

/***/ }),

/***/ "nS9i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("/GJc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127ce699_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("vPZj");
function injectStyle (ssrContext) {
  __webpack_require__("MZyj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127ce699_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nyL6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rujA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"my-container"},[_c('span',[_vm._v("Oops!")]),_vm._v(" "),_c('p',[_vm._v("The search string you entered was: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"my-input",attrs:{"readonly":""},domProps:{"value":(_vm.searchInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('p',[_vm._v("Sorry! This is an invalid search string.")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-header"},[_c('div',{staticClass:"my-header-container"},[_c('h1',[_vm._v("Search")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rukW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("3Z2V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b52e2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("TS7e");
function injectStyle (ssrContext) {
  __webpack_require__("fJxb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b52e2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "si88":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uJYF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ualu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("TbzR");


var _types$INDEXBLOCKLIST;



/* harmony default export */ __webpack_exports__["a"] = (_types$INDEXBLOCKLIST = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INDEXBLOCKLIST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].INDEXBLOCKLIST, function (state, _ref) {
  var indexBlockList = _ref.indexBlockList;

  state.indexBlockList = indexBlockList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INDEXBLOCKLIST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].MARKETINFO, function (state, _ref2) {
  var marketInfo = _ref2.marketInfo;

  state.marketInfo = marketInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INDEXBLOCKLIST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].INDEXTXNLIST, function (state, _ref3) {
  var indexTxnList = _ref3.indexTxnList;

  state.indexTxnList = indexTxnList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INDEXBLOCKLIST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].BLOCKINFO, function (state, _ref4) {
  var blockInfo = _ref4.blockInfo;

  state.blockInfo = blockInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INDEXBLOCKLIST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].BLOCKDETAIL, function (state, _ref5) {
  var blockDetail = _ref5.blockDetail;

  state.blockDetail = blockDetail;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INDEXBLOCKLIST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].TXNINFO, function (state, _ref6) {
  var txnInfo = _ref6.txnInfo;

  state.txnInfo = txnInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INDEXBLOCKLIST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].TXNDETAIL, function (state, _ref7) {
  var txnDetail = _ref7.txnDetail;

  state.txnDetail = txnDetail;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INDEXBLOCKLIST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].ACCOUNTINFO, function (state, _ref8) {
  var accountInfo = _ref8.accountInfo;

  state.accountInfo = accountInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INDEXBLOCKLIST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].ACCOUNTDETAIL, function (state, _ref9) {
  var accountDetail = _ref9.accountDetail;

  state.accountDetail = accountDetail;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INDEXBLOCKLIST, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].ACCOUNTTXNINFO, function (state, _ref10) {
  var accountTxnInfo = _ref10.accountTxnInfo;

  state.accountTxnInfo = accountTxnInfo;
}), _types$INDEXBLOCKLIST);

/***/ }),

/***/ "uuQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotFound404'
});

/***/ }),

/***/ "vPZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"applyIost-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"my-tips-container"},[_c('div',{attrs:{"id":"luckyBetIntro"}},[_c('p',[_vm._v("Lucky Bet is operating on the v1.0 Everest testnet of the IOST Blockchain. It provides a way for users to participate and try out the IOST testnet. Everest is still in its early testing phase. In order to launch a stable Mainnet, IOST engineers will be constantly pressure testing, adjusting, fixing and upgrading the testnet. This may result in instability, periods where the testnet is offline, and other abnormalities.")]),_vm._v(" "),_c('p',[_vm._v("If you encounter any issues or bugs, please email team@iost.io or report your issue via the following link:")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/feedback"}},[_vm._v("https://explorer.iost.io/feedback")]),_vm._v(" "),_c('p',{staticClass:"cn"},[_vm._v("此页面用于创建IOST主网账号，单IP每天最多创建5个账号。")]),_vm._v(" "),_c('p',[_vm._v("如果你发现了测试网络的任何Bug，欢迎发邮件给team@iost.io，或在以下网址提交给我们改进：")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/feedback"}},[_vm._v("https://explorer.iost.io/feedback")])],1)]),_vm._v(" "),_c('div',{staticClass:"my-container"},[_c('div',{staticClass:"my-err-msg",attrs:{"role":"alert","id":"errAlert"}},[_vm._v(_vm._s(_vm.errMsg))]),_vm._v(" "),_c('div',{staticClass:"my-group"},[_c('p',{},[_vm._v("Account PubKey")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim()",value:(_vm.address),expression:"address",modifiers:{"trim()":true}}],staticClass:"my-input col-sm-8",attrs:{"placeholder":"Account PubKey","id":"applyAddress"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"my-group my-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"type":"checkbox","id":"generateAddressCheck"},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}}),_vm._v(" "),_c('p',[_vm._v("Generate KeyPair for me")])]),_vm._v(" "),_c('div',{staticClass:"my-group"},[_c('p',{},[_vm._v("Private Key")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim()",value:(_vm.privKey),expression:"privKey",modifiers:{"trim()":true}}],staticClass:"my-input col-sm-8",attrs:{"disabled":""},domProps:{"value":(_vm.privKey)},on:{"input":function($event){if($event.target.composing){ return; }_vm.privKey=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"my-group"},[_c('p',{},[_vm._v("Account Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim()",value:(_vm.accountName),expression:"accountName",modifiers:{"trim()":true}}],staticClass:"my-input col-sm-8",attrs:{"placeholder":"Account Name","id":"applyName"},domProps:{"value":(_vm.accountName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.accountName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"my-group"},[_c('p',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim()",value:(_vm.email),expression:"email",modifiers:{"trim()":true}}],staticClass:"my-input",attrs:{"type":"email","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('button',{class:{active: _vm.isOK},attrs:{"type":"button","id":"RequestBuuton"},on:{"click":_vm.apply}},[_vm._v("Create")])]),_vm._v(" "),_c('div',{staticClass:"modal fade bs-example-modal-sm",attrs:{"id":"applyIOSTModal","tabindex":"-1","role":"dialog","aria-labelledby":"mySmallModalLabel"}},[_c('div',{staticClass:"modal-dialog modal-sm",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('p'),_vm._v(" "),_c('p',[_vm._v("      Creating Account"),_c('span',[_vm._v(" "+_vm._s(_vm.dott))])]),_vm._v(" "),_c('p')])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"applyIost-header"},[_c('div',{staticClass:"my-header-container"},[_c('h1',[_vm._v("Create")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-group my-recaptcha"},[_c('div',{staticClass:"g-recaptcha",attrs:{"id":"recap","data-sitekey":"6Lc1vF8UAAAAAMo-EsF4vRt6CWxM8s56lAeyHnBe"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vgtk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wUKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'accounts',
  data: function data() {
    return {
      page: ''
    };
  },

  methods: {
    fetchData: function fetchData(r) {
      if (!r.query.p) {
        this.page = 1;
      } else {
        this.page = parseInt(r.query.p);
      }

      this.$store.dispatch('getAccountInfo', this.page);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['accountInfo'])),

  watch: {
    '$route': function $route(r) {
      this.fetchData(r);
    }
  },
  mounted: function mounted() {
    this.fetchData(this.$route);
  }
});

/***/ }),

/***/ "wdrB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"Head"}}),_vm._v(" "),_c('div',{staticClass:"my-main"},[_c('router-view',{attrs:{"name":"Main"}})],1),_vm._v(" "),_c('router-view',{attrs:{"name":"Foot"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xGI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedBack-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"my-container"},[_c('div',{staticClass:"err-msg",staticStyle:{"text-align":"center"},attrs:{"role":"alert","id":"errFeedbackAlert"}},[_vm._v(_vm._s(_vm.errMsg))]),_vm._v(" "),_c('div',{staticClass:"my-group"},[_c('p',[_vm._v("Email：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.email),expression:"email",modifiers:{"trim":true}}],staticClass:"my-input",attrs:{"type":"email","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"my-group"},[_c('p',[_vm._v("Feedback：")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.content),expression:"content",modifiers:{"trim":true}}],staticClass:"my-input",staticStyle:{"resize":"none"},domProps:{"value":(_vm.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.content=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('button',{class:{active: _vm.isOK},attrs:{"type":"button"},on:{"click":_vm.sendFeedback}},[_vm._v("Send")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedBack-header"},[_c('div',{staticClass:"my-header-container"},[_c('h1',[_vm._v("Feedback")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xIGC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voteWithdraw-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"my-container"},[_vm._m(1),_vm._v(" "),_c('h3',[_vm._v("Voting reward")]),_vm._v(" "),_c('table',{staticClass:"table bonus-table"},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"width":"300px"}},[_vm._v("node name:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.account))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("reward:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.bonusVal))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-success",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.withdrawVote}},[_vm._v("claim")])])])])]),_vm._v(" "),_c('h3',[_vm._v("Block reward")]),_vm._v(" "),_c('table',{staticClass:"table bonus-table"},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"width":"300px"}},[_vm._v("node name:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.account))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("reward:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.bpVal))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-success",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.withdrawBp}},[_vm._v("claim")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voteWithdraw-header"},[_c('div',{staticClass:"my-header-container"},[_c('h1',[_vm._v("Bonus Withdraw")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bonus-info"},[_c('p',[_vm._v("投票奖励 - 系统每隔24小时会发放一次投票奖励，节点（BP和合伙人）触发领取奖励后，投票者才能领取到奖励,奖励需要手动触发领取")]),_vm._v(" "),_c('p',[_vm._v("Voting reward - The system will issue a voting reward every 24 hours. After the node（BP、partner） claim the reward, the voter can claim the reward. The reward needs to be manually claimed.")]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"20px"}},[_vm._v("造块奖励 - 造块节点每造一个块大概可以获得3.3个Token奖励，每隔24小时可以领取一次，奖励需要手动触发领取")]),_vm._v(" "),_c('p',[_vm._v("Block reward - The BP can get 3.3 Token rewards for each block, and can be claimed once every 24 hours. The reward needs to be manually claimed.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "yfzl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0d7955ee68f935138512.js